import * as R from 'ramda'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import {
  checkOldResError,
  checkResError,
  getTypeAndPayloadFromEvent,
} from '$logic/twaCommunication/helper'
import { TWA_API_SUPPORT } from '$logic/twaCommunication/constant'
import {
  parseAndroidMessage,
  parseOldAndroidMessage,
} from '$logic/twaCommunication/service'
import { TwaEvent, TwaEventTypeField } from './twaCommunication.types'
import { getPort } from './twaCommiunication.state'
import * as wsApi from './websocket'

export const setTwaTokenViaHttp = async (token: string) => {
  const port = getPort()
  if (!port) throw Error('no-port')
  await axios.get(`http://127.0.0.1:${port}/set-option?auth_token=${token}`)
}

export const sendToTwa = async (
  type: TwaEventTypeField,
  payload?: any,
  retry = true,
  binary = false,
) => {
  const ws = await wsApi.createWebsocketForConnectionToTwa()

  if (ws) ws.send(binary ? payload : `${type}/${JSON.stringify(payload)}`)
  else if (retry) sendToTwa(type, payload, false, binary)
}

export const sendEventToTwa = (
  type: TwaEventTypeField,
  payload?: any,
  timeout = 30000,
  retry = true,
  binary = false,
) =>
  new Promise((resolve, reject) => {
    if (TWA_API_SUPPORT.API_VERSION === 1) {
      sendToTwa(type, payload, retry, binary)
      return resolve(true)
    }

    const request: TwaEvent = { type, ...(payload || {}) }
    const reqId = uuidv4()
    const requestWithReqId = R.assoc('reqId', reqId, request)
    sendToTwa(
      type,
      `${type}/${JSON.stringify(R.dissoc('type', requestWithReqId))}`,
      true,
      true,
    )

    const timer = setTimeout(wsApi.getTwaPool.onTimeout, timeout, reqId)

    wsApi.getTwaPool.add(reqId, request, resolve, reject, timer)
  })

export const handleAndroidMessage = (messageEvent: MessageEvent) => {
  const { type, payload } = getTypeAndPayloadFromEvent(messageEvent.data)

  const action = { type, payload }

  if (TWA_API_SUPPORT.API_VERSION === 1) {
    const error = checkOldResError(payload)
    if (error) {
      // show error
      return
    }
    parseOldAndroidMessage(action)
    return
  }
  if (!payload) return

  const error = checkResError(payload)
  if (error) {
    // show error
    return
  }
  const { reqId } = payload
  if (reqId) {
    wsApi.resolveTwaPoolAction(reqId, action)
    return
  }
  parseAndroidMessage({ type, payload })
}
